<template>
  <div>
    <v-container>
      <v-row>
        <v-col align="center">
          <v-card elevation="8" class="pa-6 mt-8 logo-card" max-width="450" rounded="lg">
            <v-img :src="getAssetImg('/assets/logo-color-crop_wcl7z9.webp')"></v-img>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="mt-4 mb-8">
        <v-col align="center">
          <h1 class="text-h3 font-weight-bold primary--text">
            About Us
          </h1>
        </v-col>
      </v-row>
      <v-row class="mb-8">
        <v-col cols="12" lg="10" offset-lg="1">
          <v-card light elevation="12" class="about-card" rounded="lg">
            <v-container class="pa-8">
              <v-row justify="center" align="center">
                <v-col cols="12" lg="8" order="2" order-lg="1">
                  <h2 class="text-h4 font-weight-bold primary--text mb-4">Our Story</h2>
                  <p class="text-h6 font-weight-regular grey--text text--darken-2 line-height-relaxed">
                    Here at Premium Quality Drywall we are a small family owned company with big attributes. I've been
                    working in this trade for over 30 years and I truly love what I do. The fact that we are a family
                    owned company allows us to provide quality work for exceptional prices.
                  </p>
                </v-col>
                <v-col cols="12" lg="4" order="1" order-lg="2">
                  <v-img :src="getAssetImg('/v1750402427/family_tyhhxm.webp')" contain max-height="400" class="rounded-lg"></v-img>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="mb-8">
        <v-col cols="12" lg="10" offset-lg="1">
          <v-card light elevation="12" class="about-card" rounded="lg">
            <v-container class="pa-8">
              <v-row justify="center" align="center">
                <v-col cols="12" lg="4" order="1">
                  <v-img :src="getAssetImg('/v1750402427/framing_vvhcng.webp')" contain max-height="400" class="rounded-lg"></v-img>
                </v-col>
                <v-col cols="12" lg="8" order="2">
                  <h2 class="text-h4 font-weight-bold primary--text mb-4">Why Choose Us?</h2>
                  <p class="text-h6 font-weight-regular grey--text text--darken-2 line-height-relaxed">
                    We like to treat all our customers like family and we do our job as if we were enhancing our own
                    home. We have customers that have been with us for years and they keep calling us back when they
                    need anything else done. Not only because we can do any job big or small but because we develop a
                    lasting business relationship.
                  </p>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="mb-8">
        <v-col cols="12" lg="10" offset-lg="1">
          <v-card light elevation="12" class="about-card" rounded="lg">
            <v-container class="pa-8">
              <v-row justify="center" align="center">
                <v-col cols="12" lg="8" order="2" order-lg="1">
                  <h2 class="text-h4 font-weight-bold primary--text mb-4">Our Commitment</h2>
                  <p class="text-h6 font-weight-regular grey--text text--darken-2 line-height-relaxed">
                    What ultimately drives us is your satisfaction so we will do whatever it takes to provide the most
                    excellent work possible at competitive prices. So join the family and give us a call for a free
                    estimate.
                  </p>
                </v-col>
                <v-col cols="12" lg="4" order="1" order-lg="2">
                  <v-img :src="getAssetImg('/assets/putty_a3hpgd.webp')" contain max-height="400" class="rounded-lg"></v-img>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="mb-12">
        <v-col cols="12" lg="10" offset-lg="1">
          <v-card
            light
            elevation="12"
            class="about-card cta-card"
            color="primary"
            dark
            rounded="lg"
          >
            <v-container class="pa-8">
              <v-row justify="center" align="center">
                <v-col cols="12" align="center">
                  <v-icon size="64" class="mb-4">mdi-certificate</v-icon>
                  <h2 class="text-h4 font-weight-bold mb-4">
                    Licensed & Certified
                  </h2>
                  <p class="text-h6 font-weight-light mb-4">
                    We are a member of the Contractors State License Board
                  </p>
                  <v-btn
                    x-large
                    color="warning"
                    elevation="8"
                    :to="{name: 'licenses'}"
                    class="mt-2"
                  >
                    <v-icon left>mdi-file-document</v-icon>
                    View Our License and Bonds
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>

export default {
  components: {},
  name: "AboutView",
  metaInfo: {
    title: 'About Us',
    link: [{rel: 'canonical', href: 'https://www.premiumqualitydrywall.com/about'}]
  },
  data() {
    return {}
  },
};
</script>

<style scoped>
.logo-card {
  transition: all 0.3s ease;
  background: white;
}

.logo-card:hover {
  transform: translateY(-4px);
}

.about-card {
  transition: all 0.3s ease;
  background: white;
}

.about-card:hover {
  transform: translateY(-6px);
}

.cta-card {
  background: linear-gradient(135deg, #1976D2 0%, #1565C0 100%) !important;
}

.line-height-relaxed {
  line-height: 1.8;
}
</style>
